import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StockMovementMetadataResponse } from '../models/stock-movement-metadata.model';
import { StockMovementListResponse } from '../models/stock-movement.model';
import { RawMaterialDto } from '../models/raw-material.model';
import { ApiResponse } from '../../../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  public http = inject(HttpClient);

  constructor() {}

  getStockMovementMetadata(): Observable<StockMovementMetadataResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getStockMovementMetadata}`;
    return this.http.get<StockMovementMetadataResponse>(url);
  }

  searchStockMovements(filters: any, page: number, pageSize: number): Observable<StockMovementListResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.searchStockMovements}`;

    // page and pageSize as query parameters
    const params: any = {
      page,
      pageSize
    };

    // Filter criteria as request body
    const body = {
      rawMaterialType: filters.rawMaterialType || null,
      serialNumber: filters.serialNumber || null,
      rawMaterial: filters.rawMaterial || null,
      stockMovementType: filters.stockMovementType || null,
      plantSetupFk: filters.plantSetupFk || null
    };

    return this.http.post<StockMovementListResponse>(url, body, { params });
  }

  submitStockMovement(payload: any): Observable<any> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.submitStockMovement}`;
    return this.http.post<any>(url, payload);
  }

  getRawMaterials(rawMaterialType: string, plantFk: string, serialNum: string, description: string) {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getRawMaterials}`;
    const body = {
      rawMaterialType,
      plantFk,
      serialNum: serialNum && serialNum.trim() !== '' ? serialNum : '',
      description: description && description.trim() !== '' ? description : ''
    };
    return this.http.post<ApiResponse<RawMaterialDto[]>>(url, body);
  }
}
